import React from 'react'

import i18n from 'translations'

export const FunctionalAreas = [
  {
    name: i18n.t('functional-areas:name'),
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/functionalAreas/FunctionalAreasList'),
    ),
    path: '/admin/pedagogical-parameters/functional-areas',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('functional-areas:createFunctionalAreas'),
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/functionalAreas/FunctionalAreasCreate'),
    ),
    path: '/admin/pedagogical-parameters/functional-areas/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: i18n.t('functional-areas:editFunctionalAreas'),
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/functionalAreas/FunctionalAreasEdit'),
    ),
    path: '/admin/pedagogical-parameters/functional-areas/edit/:functionalAreaId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
